import { createSentryConfig } from "@9amhealth/shared";
import envVariables from "./envVariables";

export const sentryConfig = createSentryConfig({
  dsn: envVariables.SENTRY_DSN,
  environment: envVariables.ENV_NAME,
  enabled: envVariables.PROD,
  release: `9am-${envVariables.APP_ENV}@${envVariables.BUILD_VERSION}`,
  ignoreErrors: [
    "Failed to load Stripe.js",
    "Customer.io message error",
    "No new version available",
    "Biometric verification failed",
    "disable_auto_update_under_native",
    /Failed to download from: https:\/\/app-archive.dev.join9am.com(.*)/,
    /^Long-running loading state: [0-9a-fA-F-]{36}$/,
    "Long-running loading state: avatar"
  ]
});
